<template>
  <el-dialog
    title="提现详情"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    @close="handleClose">
    <el-form label-width="140px" size="small" class="detail-form" v-loading="loading">
      <div class="formTitle">提现信息</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="提现编号">
            <span>{{ detailData.withdrawalNo }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申请时间">
            <span>{{ detailData.applyTime | filterTime }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="提现金额">
            <span style="color: #E6A23C; font-weight: bold;">¥{{ detailData.amount | filterMoney }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手续费">
            <span>¥{{ detailData.fee | filterMoney }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="实际到账">
            <span style="color: #67C23A; font-weight: bold; font-size: 16px;">¥{{ detailData.actualAmount | filterMoney }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="到账天数">
            <span>{{ getArrivalDaysLabel(detailData.arrivalDays) }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="formTitle">渠道信息</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="渠道编号">
            <span>{{ detailData.channelNo }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="渠道姓名">
            <span>{{ detailData.channelName }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="formTitle">支付宝信息</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="支付宝账号">
            <span>{{ detailData.alipayAccount }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="支付宝姓名">
            <span>{{ detailData.alipayName }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="formTitle">审核信息</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="审核状态">
            <el-tag :type="getWithdrawalStatusType(detailData.status)">
              {{ detailData.status | filterConst('CHANNEL_WITHDRAWAL_STATUS') }}
            </el-tag>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="审核时间">
            <span>{{ detailData.auditTime | filterTime }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="审核人">
            <span>{{ detailData.auditOperator || '-' }}</span>
          </el-form-item>
        </el-col>
      
        <el-col :span="12">
          <el-form-item label="审核备注">
            <span>{{ detailData.auditRemark || '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
     
     
      <div class="formTitle">转账信息</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="转账状态">
            <el-tag v-if="detailData.transferStatus === 1" type="success">转账成功</el-tag>
            <el-tag v-else-if="detailData.transferStatus === 2" type="danger">转账失败</el-tag>
            <span v-else>-</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="转账时间">
            <span>{{ detailData.transferTime | filterTime }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="detailData.transferStatus === 2 && detailData.transferFailReason">
        <el-col :span="24">
          <el-form-item label="转账失败原因">
            <span>{{ detailData.transferFailReason }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'WithdrawalDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    withdrawalId: {
      type: [Number, String],
      default: null
    },
    // 类型：用于区分调用来源
    type: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      detailData: {
        withdrawalNo: '',
        applyTime: '',
        amount: 0,
        fee: 0,
        actualAmount: 0,
        arrivalDays: 0,
        status: null,
        channelNo: '',
        channelName: '',
        alipayAccount: '',
        alipayName: '',
        auditTime: '',
        auditOperator: '',
        auditRemark: '',
        transferStatus: null,
        transferTime: '',
        transferFailReason: ''
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val && this.withdrawalId) {
        this.loadDetail()
      }
    },
    withdrawalId(val) {
      if (val && this.visible) {
        this.loadDetail()
      }
    }
  },
  methods: {
    /**
     * 获取提现详情
     * 使用接口：GET /api/v1/channel/withdrawal/detail
     * 作者：孙艺
     */
    async loadDetail() {
      if (!this.withdrawalId) {
        return
      }
      
      this.loading = true
      try {
        const res = await this.$axios.get('/api/v1/channel/withdrawal/detail', { id: this.withdrawalId })
        if (res && res.code === 1 && res.data) {
          const detail = res.data
          // 字段映射
          this.detailData = {
            id: detail.id || detail.withdrawalId,
            amount: detail.withdrawalAmount,
            fee: detail.serviceFee,
            status: detail.auditStatus,
            withdrawalNo: detail.withdrawalNo,
            channelId: detail.channelId,
            channelNo: detail.channelNo,
            channelName: detail.channelName,
            actualAmount: detail.actualAmount,
            arrivalDays: detail.arrivalDays || 0,
            alipayAccount: detail.alipayAccount,
            alipayName: detail.alipayName,
            applyTime: detail.applyTime,
            auditTime: detail.auditTime,
            auditOperator: detail.auditOperator,
            auditRemark: detail.auditRemark,
            transferStatus: detail.transferStatus,
            transferTime: detail.transferTime,
            transferFailReason: detail.transferFailReason,
            organizationId: detail.organizationId,
            organizationName: detail.organizationName
          }
        }
      } catch (error) {
        console.error('获取提现详情失败:', error)
        this.$message.error('获取提现详情失败')
      } finally {
        this.loading = false
      }
    },
    /**
     * 获取提现状态类型
     * 作者：孙艺
     */
    getWithdrawalStatusType(status) {
      const statusItem = this.$const.CHANNEL_WITHDRAWAL_STATUS.find(i => i.value === status)
      return statusItem ? statusItem.type : ''
    },
    /**
     * 获取到账天数标签
     * 作者：孙艺
     */
    getArrivalDaysLabel(days) {
      const item = this.$const.CHANNEL_WITHDRAWAL_ARRIVAL_DAYS.find(i => i.value == String(days))
      return item ? item.label : `${days || 0}天`
    },
    /**
     * 关闭对话框
     * 作者：孙艺
     */
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../channel.less';

.detail-form {
  /deep/ .el-form-item {
    margin-bottom: 8px;
  }
  
  /deep/ .el-row {
    margin-bottom: 0;
  }
  
  /deep/ .formTitle {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  
  /deep/ .formTitle:first-child {
    margin-top: 0;
  }
}
</style>

